import { deserialize, serialize } from "serializr";

import _axiosInstance from "../../interceptor/_axiosInstance";

import { FilterLeaderboard } from "../../models/LeaderboardModel/Leaderboard.model";
import { ActivitySummaryModel, ActivityDetailsModel } from "../../models/ReportsModel/activity.model";

import { ACTIVITY_SUMMARY, DOWNLOAD_ACTIVITY_SUMMARY, ACTIVITY_SUBMISSION_DETAILS } from "../../routes/routeConstants/apiRoutes";
import { defaultFilterReports } from "../../shared/utils/filter";


export default class ActivityReportsService {

    static fetchActivityReportByInst(
        data: FilterLeaderboard,
        onSuccess: (data: ActivitySummaryModel[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        const payload = serialize(FilterLeaderboard, { ...defaultFilterReports, ...data })
        delete payload.type;
        return _axiosInstance.get(ACTIVITY_SUMMARY, { params: payload })
            .then(response => {
                const data = deserialize(ActivitySummaryModel, response?.["data"]) as ActivitySummaryModel[];
                onSuccess(data);
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }

    static fetchActivitySubmissionDetails(
        params: any,
        onSuccess: (data: ActivityDetailsModel[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return _axiosInstance.get(ACTIVITY_SUBMISSION_DETAILS, { params })
            .then((response) => {
                const data = deserialize(ActivityDetailsModel, response?.["data"]) as ActivityDetailsModel[];
                onSuccess(data);
            })
            .catch((e) => {
                onError(e);
            })
            .finally(onFinal);
    }

    static downloadActivitySummary(
        data: FilterLeaderboard,
        onSuccess: (value: any) => void,
        onError: Function,
        onFinal: () => void
    ) {
        const payload = serialize(FilterLeaderboard, { ...defaultFilterReports, ...data })
        delete payload.type;
        return _axiosInstance.get(DOWNLOAD_ACTIVITY_SUMMARY, { params: payload })
            .then((response) => new Blob([response.data]))
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `Report.csv`,
                );
                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode?.removeChild(link);

                onSuccess("Download");
            })
            .catch((e) => {
                onError(e);
            })
            .finally(onFinal);
    }
}   